clearStoreCallbacks